import { render, staticRenderFns } from "./TarjetasEmergencia.vue?vue&type=template&id=7c811086"
import script from "./TarjetasEmergencia.vue?vue&type=script&lang=js"
export * from "./TarjetasEmergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports